import { render, staticRenderFns } from "./plogdetail.vue?vue&type=template&id=09890fe0&scoped=true&"
import script from "./plogdetail.vue?vue&type=script&lang=js&"
export * from "./plogdetail.vue?vue&type=script&lang=js&"
import style0 from "./plogdetail.vue?vue&type=style&index=0&id=09890fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09890fe0",
  null
  
)

export default component.exports